import { IoPersonAddOutline } from "react-icons/io5";
import { useEffect, useState } from "react";
import ModalCommonOpt from "screens/roleta/components/modalOpt";
import InputComponent from "components/InputG";
import * as S from "./styles";
import * as IconsSVG from "../../../../../assets/iconsSVG";

interface IPesquisarCorretorProps {
  onChangePalavraChave: (value: string) => void;
  dataListarFila: any;
  refetchListarFila: () => void;
}

const PesquisarCorretor = ({
  onChangePalavraChave,
  refetchListarFila,
  dataListarFila,
}: IPesquisarCorretorProps) => {
  const [isOpenAdicionarCorretor, setIsOpenAdicionarCorretor] = useState(false);
  const [palavraChave, setPalavraChave] = useState("");

  const handlePesquisar = async () => {
    await onChangePalavraChave(palavraChave);
    refetchListarFila();
  };

  return (
    <S.Content>
      <S.Row>
        <S.Column style={{ width: "454px" }}>
          <S.Subtitle>Pesquisar corretor</S.Subtitle>
          <InputComponent
            onChange={(e) => {
              const { value } = e.target;
              setPalavraChave(value);
              onChangePalavraChave(value);
            }}
            value={palavraChave}
            placeholder="Digite o nome do corretor"
            borderRadius="8px"
            buttonAction={() => {
              handlePesquisar();
            }}
            onKeyPress={(e) => e.key === "Enter" && handlePesquisar()}
          />
        </S.Column>
        <S.Column style={{ width: "303px" }}>
          <S.Button onClick={() => setIsOpenAdicionarCorretor(true)}>
            <IoPersonAddOutline size={20} />
            Adicionar Corretor na Fila manualmente
          </S.Button>
        </S.Column>
      </S.Row>
      <ModalCommonOpt
        icon={() => <IconsSVG.AddPersonIcon />}
        title="Adicionar Corretor na Fila manualmente"
        open={isOpenAdicionarCorretor}
        setOpen={setIsOpenAdicionarCorretor}
        isCorretor
        isAdicionarCorretor
        idRoletaCheckin={dataListarFila?.idRoletaCheckin}
        refetchListarFila={refetchListarFila}
      />
    </S.Content>
  );
};
export default PesquisarCorretor;
